import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../../actions/entries';
import * as nationsActionCreators from '../../actions/nations';
import * as feiIdActionCreators from '../../actions/feiId';
import * as vaultersActionsCreators from '../../actions/vaulters';
import * as lungersActionsCreators from '../../actions/lungers';
import * as horsesActionsCreators from '../../actions/nationHorses';

import { EntryList, CreateEntry, EntryFilter } from '../../components/entry';
import { competitions } from '../../constants/values';

const mapStateToProps = (state, ownProps) => ({
  token: state.auth.token,
  isLoggedIn: state.auth.isLoggedIn,
  isAdmin: state.auth.isAdmin,
  nation: ownProps.params.nation || state.auth.nation,
  entries: state.entries.entries,
  nations: state.nations.nations,
  athlete: state.feiId.athlete,
  vaulters: state.vaulters.vaulters,
  lungers: state.lungers.lungers,
  nationHorses: state.nationHorses.nationHorses,
  isPushingData: state.entries.isPushingData,
  isDeletingData: state.entries.isDeletingData,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch),
  nationsActions: bindActionCreators(nationsActionCreators, dispatch),
  feiIdActions: bindActionCreators(feiIdActionCreators, dispatch),
  vaultersActions: bindActionCreators(vaultersActionsCreators, dispatch),
  lungersActions: bindActionCreators(lungersActionsCreators, dispatch),
  horsesActions: bindActionCreators(horsesActionsCreators, dispatch),
});

class EntryManagement extends Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    nation: PropTypes.string.isRequired,
    entries: PropTypes.array.isRequired,
    nations: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
    athlete: PropTypes.object.isRequired,
    nationsActions: PropTypes.object.isRequired,
    feiIdActions: PropTypes.object.isRequired,
    isPushingData: PropTypes.bool.isRequired,
    isDeletingData: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    const { nation } = this.props;

    this.state = {
      filters: {
        nation: nation === 'ADMIN' || !nation ? undefined : nation,
        competition: competitions[0].value,
      },
    };
  }

  componentWillMount() {
    const { filters } = this.state;

    this.fetchData(filters);
  }

  loadEntities = () => {
    this.fetchVaulters();
    this.fetchLungers();
    this.fetchNationHorses();
  };

  fetchData(filters) {
    const { token, actions, nationsActions } = this.props;

    actions.fetchEntries(token, { filters });

    nationsActions.fetchNations();
  }

  fetchVaulters() {
    const { nation, token, vaultersActions } = this.props;

    vaultersActions.fetchVaulters(nation, token);
  }

  fetchLungers() {
    const { nation, token, lungersActions } = this.props;

    lungersActions.fetchLungers(nation, token);
  }

  fetchNationHorses() {
    const { nation, token, horsesActions } = this.props;

    horsesActions.fetchNationHorses(nation, token);
  }

  fetchAthleteByFeiId = (feiId, type) => {
    const { token, feiIdActions } = this.props;

    return feiIdActions.fetchAthleteByFeiId(token, feiId, type);
  };

  createEntry = entryData => {
    const { token, actions } = this.props;

    return actions.createEntry(token, entryData);
  };

  deleteEntry = entryId => {
    const { token, actions } = this.props;

    return actions.deleteEntry(token, entryId);
  };

  editEntry = (entryId, entryData) => {
    const { token, actions } = this.props;

    return actions.editEntry(token, entryId, entryData);
  };

  changeFilter = (filterName, filterValue) => {
    const { filters } = this.state;

    const value = filterName === 'nation' && filterValue === 'ADMIN' ? undefined : filterValue;

    filters[filterName] = value;

    this.setState({ filters });

    this.fetchData(filters);
  };

  submitEntitiesData = (data, vaulterId, lungerId, horseId) => {
    const { token, horsesActions, vaultersActions, lungersActions } = this.props;

    const lunger = {
      _id: lungerId,
      nation: data.nation,
      details: {
        lungerFeiId: data.details.lungerFeiId,
        lungerFirstName: data.details.lungerFirstName,
        lungerLastName: data.details.lungerLastName,
      },
    };

    const vaulter = {
      _id: vaulterId,
      nation: data.nation,
      details: {
        vaulterFeiId: data.details.vaulterFeiId,
        vaulterFirstName: data.details.vaulterFirstName,
        vaulterLastName: data.details.vaulterLastName,
        vaulterGender: data.details.vaulterGender,
        vaulterDateOfBirth: data.details.vaulterDateOfBirth,
      },
    };

    const horse = {
      _id: horseId,
      nation: data.nation,
      details: {
        horseFeiId: data.details.horseFeiId,
        horseName: data.details.horseName,
      },
    };

    lungersActions.addLunger(lunger, token);
    vaultersActions.addVaulter(vaulter, token);
    horsesActions.addHorse(horse, token);
  };

  render() {
    const {
      entries,
      isPushingData,
      isDeletingData,
      isAdmin,
      isLoggedIn,
      nation,
      nations,
      athlete,
      vaulters,
      lungers,
      nationHorses,
    } = this.props;
    const { filters } = this.state;

    return (
      <div>
        <Row>
          <Col xs={isAdmin ? 12 : 10}>
            <h3 style={{ marginBottom: isAdmin ? 0 : undefined }}>Entries Management</h3>
          </Col>

          <Col xs={2} xsOffset={isAdmin ? 10 : 0}>
            <CreateEntry
              onSubmitForm={this.createEntry}
              isPushingData={isPushingData}
              nation={nation}
              isAdmin={isAdmin}
              competition={filters.competition}
              fetchAthleteByFeiId={this.fetchAthleteByFeiId}
              athlete={athlete}
              allVaulters={vaulters}
              lungers={lungers}
              horses={nationHorses}
              submitEntitiesData={this.submitEntitiesData}
              loadEntities={this.loadEntities}
            />
          </Col>
        </Row>

        <EntryFilter
          hideNation={isLoggedIn && !isAdmin}
          isAdmin={isAdmin}
          filters={filters}
          onChangedFilter={this.changeFilter}
          registeredNations={nations}
        />

        <EntryList
          competition={filters.competition}
          entries={entries}
          onDeleteEntry={this.deleteEntry}
          isDeletingData={isDeletingData}
          onEditEntry={this.editEntry}
          isPushingData={isPushingData}
          allVaulters={vaulters}
          lungers={lungers}
          horses={nationHorses}
          isAdmin={isAdmin}
          nation={nation}
          fetchAthleteByFeiId={this.fetchAthleteByFeiId}
          athlete={athlete}
          loadEntities={this.loadEntities}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EntryManagement)


// WEBPACK FOOTER //
// ./src/components/entry/EntryManagement.js